interface IMetaData {
  pageSlug: string;
  logoLink: string;
  pageDescription: string;
  pageTitle: string;
}

export const metaData = (props: IMetaData) => {
  const {
    logoLink = 'https://pdn66.ru/_nuxt/img/logo.32b0a79.png',
    pageDescription = '',
    pageTitle = '',
    pageSlug,
  } = props;

  return [
    {
      hid: 'og:title',
      name: 'og:title',
      property: 'og:title',
      content: pageTitle || '',
    },
    {
      hid: 'og:type',
      name: 'og:type',
      property: 'og:type',
      content: 'website',
    },
    {
      hid: 'og:site_name',
      name: 'og:site_name',
      property: 'og:site_name',
      content: 'Бетонстрой',
    },
    {
      hid: 'og:description',
      name: 'og:description',
      property: 'og:description',
      content: pageDescription,
    },
    {
      hid: 'og:image',
      name: 'og:image',
      property: 'og:image',
      content: `${logoLink}`,
    },
    {
      hid: 'og:url',
      name: 'og:url',
      property: 'og:url',
      content: `https://pdn66.ru${pageSlug}`,
    },
  ];
};
